import React from "react";
import { useTranslation } from "react-i18next";
import { URL_LOG_WOOD } from "../../constance/urls";
import ReportLogWoodDetail from "../../components/reports/ReportLogWoodDetail";

function ReportLogWoodLengthByCompanyView() {
  const { t } = useTranslation();

  const columns = [
    {
      title: t("datas.index"),
      dataIndex: "index",
      key: "index",
      width: 80,
    },
    {
      title: t("truck_companies.code"),
      dataIndex: "truck_company_code",
      key: "truck_company_code",
      width: 120,
    },
    {
      title: t("truck_companies.name"),
      dataIndex: "truck_company_name",
      key: "truck_company_name",
      width: 220,
    },
    {
      title: t("long_wood_lenght.pcs_title"),
      children: [
        {
          title: t("long_wood_lenght.random"),
          dataIndex: ["report", "sum_amount"],
          key: "sum_amount",
        },
        {
          title: t("long_wood_lenght.standard"),
          dataIndex: ["report", "meet_criteria"],
          key: "meet_criteria",
        },
        {
          title: t("long_wood_lenght.over_len"),
          dataIndex: ["report", "over_criteria"],
          key: "over_criteria",
        },
        {
          title: t("long_wood_lenght.under_len"),
          dataIndex: ["report", "under_criteria"],
          key: "under_criteria",
        },
      ],
    },
    {
      title: t("long_wood_lenght.percent_title"),
      children: [
        {
          title: t("long_wood_lenght.standard"),
          dataIndex: ["report", "meet_criteria_percent"],
          key: "meet_criteria_percent",
          render: (value) => <p>{parseFloat(value).toFixed(2)}</p>,
        },
        {
          title: t("long_wood_lenght.over_len"),
          dataIndex: ["report", "over_criteria_percent"],
          key: "over_criteria_percent",
          render: (value) => <p>{parseFloat(value).toFixed(2)}</p>,
        },
        {
          title: t("long_wood_lenght.under_len"),
          dataIndex: ["report", "under_criteria_percent"],
          key: "under_criteria_percent",
          render: (value) => <p>{parseFloat(value).toFixed(2)}</p>,
        },
      ],
    },
    {
      title: t("memo"),
      dataIndex: "note",
      key: "note",
      width: 160,
    },
  ];

  return (
    <>
      <ReportLogWoodDetail
        title={t('menus.report_menus.log_wood_menus.log_wood_length_by_customer')}
        url={URL_LOG_WOOD.REPORT_LOG_WOOD_LENGTH_CUSTOMER}
        tableColumns={columns}
        exportUrl={URL_LOG_WOOD.REPORT_LOG_WOOD_LENGTH_CUSTOMER_EXPORT}
        hideCustomerFilter
      />
    </>
  );
}


export default ReportLogWoodLengthByCompanyView;